<template>
  <div class="stars-container">
    <canvas id="c1"></canvas>
    <canvas id="c2"></canvas>
  </div>
</template>

<script>

export default {
  name: "CanvasStars",
  data() {
    return {
      cw: 0,
      ch: 0,
      c1: null,
      c2: null,
      ctx1: null,
      ctx2: null,
      twopi: Math.PI * 2,
      parts: [],
      sizeBase: 0,
      opt: null,
      hue: null,
      count: 0
    }
  },
  mounted() {

    this.c1 = document.getElementById( 'c1' ),
    this.ctx1 = this.c1.getContext( '2d' ),
    this.c2 = document.getElementById( 'c2' ),
    this.ctx2 = this.c2.getContext( '2d' ),

    this.resize();
    this.create();
    this.loop();

    window.addEventListener( 'resize', this.resize );
  },
	methods: {
    rand( min, max ) {
      return Math.random() * ( max - min ) + min;
    },
    hsla( h, s, l, a ) {
      return 'hsla(' + h + ',' + s + '%,' + l + '%,' + a + ')';
    },
    loop() {
      requestAnimationFrame( this.loop );

      this.ctx2.clearRect( 0, 0, this.cw, this.ch );
      this.ctx2.globalCompositeOperation = 'source-over';
      this.ctx2.shadowBlur = 0;
      this.ctx2.drawImage( this.c1, 0, 0 );
      this.ctx2.globalCompositeOperation = 'lighter';

      let i = this.parts.length;
      this.ctx2.shadowBlur = 15;
      this.ctx2.shadowColor = '#fff';
      while( i-- ) {
        let part = this.parts[ i ];

        part.x += Math.cos( part.angle ) * part.vel;
        part.y += Math.sin( part.angle ) * part.vel;
        part.angle += this.rand( -0.05, 0.05 );

        this.ctx2.beginPath();
        this.ctx2.arc( part.x, part.y, part.radius, 0, this.twopi );
        this.ctx2.fillStyle = this.hsla( 0, 0, 100, 0.075 + Math.cos( part.tick * 0.02 ) * 0.05 );
        this.ctx2.fill();

        if( part.x - part.radius > this.cw ) { part.x = -part.radius }
        if( part.x + part.radius < 0 )  { part.x = this.cw + part.radius }
        if( part.y - part.radius > this.ch ) { part.y = -part.radius }
        if( part.y + part.radius < 0 )  { part.y = this.ch + part.radius }

        part.tick++;
      }
    },
    resize() {
      this.cw = this.c1.width = this.c2.width = window.innerWidth,
      this.ch = this.c1.height = this.c2.height = window.innerHeight;
    },
    create() {
      this.sizeBase = this.cw + this.ch;
      this.count = Math.floor( this.sizeBase * 0.3 ),
      this.hue = this.rand( 0, 360 ),
      this.opt = {
        radiusMin: 1,
        radiusMax: this.sizeBase * 0.04,
        blurMin: 10,
        blurMax: this.sizeBase * 0.04,
        hueMin: hue,
        hueMax: hue + 100,
        saturationMin: 10,
        saturationMax: 70,
        lightnessMin: 20,
        lightnessMax: 50,
        alphaMin: 0.1,
        alphaMax: 0.5
      }
      this.ctx1.clearRect( 0, 0, this.cw, this.ch );
      this.ctx1.globalCompositeOperation = 'lighter';
      while( this.count-- ) {
        var radius = this.rand( this.opt.radiusMin, this.opt.radiusMax ),
          // blur = this.rand( this.opt.blurMin, this.opt.blurMax ),
          x = this.rand( 0, this.cw ),
          y = this.rand( 0, this.ch ),
          hue = this.rand(this.opt.hueMin, this.opt.hueMax );
          // saturation = this.rand( this.opt.saturationMin, this.opt.saturationMax ),
          // lightness = this.rand(  this.opt.lightnessMin, this.opt.lightnessMax ),
          // alpha = this.rand( this.opt.alphaMin, this.opt.alphaMax );
        // this.ctx1.shadowColor = this.hsla( hue, saturation, lightness, alpha );
        // this.ctx1.shadowBlur = blur;
        this.ctx1.beginPath();
        this.ctx1.arc( x, y, radius, 0, this.twopi );
        this.ctx1.closePath();
        // this.ctx1.fill();
      }

      this.parts.length = 0;
      for( var i = 0; i < Math.floor( ( this.cw + this.ch ) * 0.03 ); i++ ) {
        this.parts.push({
          radius: this.rand( 1, this.sizeBase * 0.03 ),
          x: this.rand( 0, this.cw ),
          y: this.rand( 0, this.ch ),
          angle: this.rand( 0, this.twopi ),
          vel: this.rand( 0.1, 0.5 ),
          tick: this.rand( 0, 10000 )
        });
      }
    }
	}
}
</script>
<style scoped lang="scss">

.stars-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
    canvas {
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }
}
</style>
